import React, { useEffect, useRef } from "react";

export default function CanvasCopy({ source, width, height, style }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || !source) return;
    const ctx = el.getContext("2d", { alpha: false, desynchronized: false });
    
    // CRITICAL for mobile: Enable high-quality smoothing when downscaling
    // WebP images are 4x resolution, so we need smooth interpolation
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    
    ctx.clearRect(0, 0, width, height);
    ctx.drawImage(source, 0, 0);
  }, [source, width, height]);
  return (
    <canvas
      ref={ref}
      className="fb-page-canvas"
      width={width}
      height={height}
      aria-hidden="true"
      style={style}
    />
  );
}
